import type { HTMLAttributes, ReactNode } from 'react'

export function Card({ title, action, header, footer, elevation = '1', children, className = '', ...props }: HTMLAttributes<HTMLElement> & { title?: string; action?: ReactNode; header?: ReactNode; footer?: ReactNode; elevation?: '1' | '2' | '3'; children: ReactNode }) {
  return <section {...props} className={`ui-card ui-card-elev-${elevation} ${className}`}>
    {(title || action || header) && <header className="ui-card-header">{header ?? <>{title && <h2>{title}</h2>}{action}</>}</header>}
    <div className="ui-card-body">{children}</div>
    {footer && <footer className="ui-card-footer">{footer}</footer>}
  </section>
}
